import type { FC } from 'react';
import { Tab as MwlTab } from '@mwl/ui';
import { Button } from '../Button/Button';
import type { TabProps } from './Tab.types';
const Tab: FC<TabProps> = ({
  label,
  className,
  active,
  ...otherProps
}) => {
  return <MwlTab component={Button} className={className} variant={active ? 'lined' : 'text'} color={active ? 'red' : 'grey-light'} active={active} {...otherProps} data-sentry-element="MwlTab" data-sentry-component="Tab" data-sentry-source-file="Tab.tsx">
      {label}
    </MwlTab>;
};
export { Tab };